import { createFileRoute } from "@tanstack/react-router";
import Radgivning from "@/pages/Radgivning";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildPageSchema, buildSeoHead, buildServiceSchema, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/radgivning")({
  head: () =>
    buildSeoHead(
      publicPageSeo.radgivning,
      [
        buildPageSchema(publicPageSeo.radgivning, "WebPage"),
        buildServiceSchema(publicPageSeo.radgivning, "Ekonomisk rådgivning och företagsrådgivning", [
          "Lönsamhetsstyrning",
          "Budget och prognos",
          "K10 och 3:12",
          "Företagsrådgivning",
        ]),
        buildBreadcrumbSchema(getBreadcrumbTrail("/radgivning") ?? []),
      ],
    ),
  component: Radgivning,
});
